import React, { Component } from "react";


export default class UsersSettings extends Component {
  render() {
    return (
      <div>
        <div className="row m-0 mt-3">
          <div className="col-md-6">
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Signup
              </label>
              <select class="custom-select col-8">
                <option selected="">Direct </option>
                <option value="1">Direct + Captcha</option>
              </select>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-4 text-right" for="inputDefault">
                Default user type
              </label>
              <select class="custom-select col-8">
                <option selected="">Super Admin </option>
                <option value="1">Admin Type</option>
                <option value="2">Trainer Type</option>
                <option value="3">Learner Type</option>
              </select>
            </div>
          </div>
        </div>

        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary"> Save</div> or{" "}
          <a className="btn-link">Cancel</a>
        </div>
      </div>
    );
  }
}
